import UAParser from 'ua-parser-js';

const visitorStorageKey = 'napkin.identity.visitor';

function getAppUrl() {
  return 'https://app.napkin.ai';
}

function isProduction() {
  // Check if the hostname is www.napkin.ai or query parameter isProduction is set to true
  return window.location.hostname.includes('www.napkin.ai') || new URLSearchParams(window.location.search).get('isProduction') === 'true';
}

function loadScript(url, { defer = false, crossorigin = null } = {}) {
  return new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = url;
    script.defer = defer;
    if (crossorigin) {
      script.crossorigin = crossorigin;
    }
    script.onload = resolve;
    script.onerror = (e) => {
      window.scriptsErrors.push('Failed to load script: ' + url);
      reject(e);
    };
    document.head.appendChild(script);
  });
}

function trackClickById(id, callback) {
  const element = document.getElementById(id);
  if (element) {
    element.onclick = callback;
  }
}

function checkIfDeviceAllowsEditing() {
  try {
    let parser = new UAParser();
    let deviceType = parser.getDevice().type;
    if (deviceType == 'mobile' || deviceType == 'tablet' || deviceType == 'console') return false;
    let mQPointer = window.matchMedia('(pointer: fine)');
    if (mQPointer.media == '(pointer: fine)' && mQPointer.matches) {
      return true;
    }
    return parser.getOS().name == 'Windows';
  } catch (e) {
    console.error('Failed to check if device allows editing: ', e);
    return false;
  }
}

function getRandomString() {
  if (self && self.crypto && typeof self.crypto.randomUUID === 'function') {
    // Use the native crypto.randomUUID() function if available
    // (https://developer.mozilla.org/en-US/docs/Web/API/Crypto/getRandomValues)
    // (https://developer.mozilla.org/en-US/docs/Web/API/Crypto/randomUUID)
    return self.crypto.randomUUID();
  }
  // Otherwise, fallback to a random string generator
  return Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
}

function getVisitor() {
  let visitor = null;
  try {
    visitor = sessionStorage.getItem(visitorStorageKey);
  } catch (e) {
    console.warn('Failed to get visitor from sessionStorage: ', e);
  }

  if (!visitor) {
    visitor = decodeURIComponent(document.cookie)
      .split('; ')
      .find((row) => row.startsWith(visitorStorageKey + '='))
      ?.split('=')[1];
  }
  if (!visitor) {
    visitor = 'visitor@' + getRandomString();
  }

  // Store visitor
  try {
    sessionStorage.setItem(visitorStorageKey, visitor);
  } catch (e) {
    console.warn('Failed to set visitor in sessionStorage: ', e);
  }

  try {
    document.cookie =
      visitorStorageKey +
      '=' +
      encodeURIComponent(visitor) +
      '; domain=' +
      (window.location.hostname == 'localhost' ? 'localhost' : '.napkin.ai') +
      '; sameSite=None; Secure';
  } catch (e) {
    console.warn('Failed to set visitor in cookie: ', e);
  }

  return visitor;
}

export { 
  isProduction,
  loadScript,
  trackClickById,
  checkIfDeviceAllowsEditing,
  getVisitor,
  getRandomString,
  getAppUrl
};